import i18n from '@/i18n';
import H_time from '@/helpers/time';
import H_file from '@/helpers/file';
import H_guidelineVersionAdmin from '@/helpers/guidelineVersionAdmin';
export default {
  setDropdown(rawDataList, versionId) {
    return {
      selectedItem: !rawDataList || !rawDataList.length
        ? ''
        : versionId && rawDataList.some(data => data.id === versionId)
        ? versionId
        : rawDataList[0].id,
      items: rawDataList.map(({
        id, announce_at, is_released
      }) => ({
        id,
        textLabel: `${H_time.getDateDashFormat(announce_at)}${is_released === 0 ? ` (${i18n.t('未發布')})` : ''}`
      })),
    };
  },
  setShow({
    id,
    name,
    announce_at,
    effect_at,
    remark,
    attaches,
    act_version_alls,
    article_versions,
    related_guidelines,
    has_audit,
    has_checklist,
    has_guideline_article_version,
    has_guideline_version,
    has_internal_training,
    has_license,
    has_task,
  }) {
    return {
      id,
      name,
      announceAt: H_time.getDateDashFormat(announce_at),
      effectAt: H_time.getDateDashFormat(effect_at),
      remark,
      attaches: H_file.setShowInModule(attaches),
      lawCardList: this.setLawCardList({act_version_alls, article_versions}),
      guidelineList: H_guidelineVersionAdmin.setShowRelatedGuideline(related_guidelines),
      has_audit,
      has_checklist,
      has_guideline_article_version,
      has_guideline_version,
      has_internal_training,
      has_license,
      has_task,
    };
  },
  setLawCardList({act_version_alls, article_versions}) {
    const act = act_version_alls.map(({id: versionId, name: title, act: {id}}) => ({
      id,
      title,
      versionId,
      type: 'act',
    }));
    const article = article_versions.map(({article: {id}, act_version, act_versions, no_text, id: versionId, }) => {
      return {
        id,
        title: `${
          act_version
            ? act_version.name
            : act_versions[0].name
        } ${no_text ? no_text : ""}`,
        versionId,
        actVersionId: act_version
          ? act_version.id
          : act_versions[act_versions.length -1].id,
        type: 'article',
      };
    });
    return [...act, ...article];
  }
}